// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forms-sample .form-group .input {
  display: grid;
  grid-auto-flow: column;
  position: relative;
}

.forms-sample .form-group .input img {
  position: absolute;
  width: 80px;
  right: 12px;
  padding: 0px;
  height: 40px;
  border-radius: 25.0415px;
  border: 4px solid rgb(36 186 239 / 30%);
}

/* .active > .page-link,
.page-link.active {
  background-color: #328da7;
  border-color: #328da7;
}

.page-link {
  color: #328da7;
} */

.joblist {
  background-color: #fff;
  padding: 50px 30px;
}

.joblist h3 {
  color: #000;
}

/* Sidebar */
.sidebar {
  /* position: fixed; */
  top: 82px;
  bottom: 0;
  left: 0;
  padding: 0px 0 0;
  /* box-shadow: 0 2px 5px 0 rgb(0 0 0 / 5%), 0 2px 10px 0 rgb(0 0 0 / 5%); */
  width: 240px;
  z-index: 600;

  background-color: #f3f6f9 !important;
  padding-bottom: 22px;
}
.position-sticky {
  background-color: #f3f6f9;
}
@media (max-width: 991.98px) {
  .sidebar {
    width: 100%;
  }
}
.sidebar .active {
  border-radius: 5px;
  /* box-shadow: 0 2px 5px 0 rgb(0 0 0 / 16%), 0 2px 10px 0 rgb(0 0 0 / 12%); */
  background-color: #55b56d;
  border-color: #55b56d;
  border-radius: 0px;
}
.sidebar-sticky {
  position: relative;
  top: 0;
  height: calc(100vh - 48px);
  padding-top: 0.5rem;
  overflow-x: hidden;
  overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
}

.rightside {
  width: 80%;
  padding: 25px 30px;
  background-color: #f3f6f9;
}

.profile header {
  justify-content: space-between;
}
.profile {
 padding-top: 10px;
}


.profiless-img input {
  width: 40px;
  height: 40px;
  opacity: 0;
  cursor: pointer;
  position: absolute;
  right: 80px;
  top: 74px;
  z-index: 11;
}

.profiless-img {
  position: relative;
}

.profiless-img i.fa.fa-camera {
  /* background-color: #55b56d; */
  width: 40px;
  height: 40px;
  position: absolute;
  right: 80px;
  top: 74px;
  text-align: center;
  padding: 9px 8px;
  border-radius: 50%;
  color: #55b56d;
  z-index: 10;
}

.camping-hd h4 {
  color: #212121;
  font-size: 18px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}
.camping-hd p {
  color: #b5b5c3;
  font-size: 12px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}
.btn-all {
  border-radius: 5px;
  background: #55b56d;
  color: #fff;
  font-size: 12px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  /* width: 140px; */
  height: 41px;
  padding: 12px 15px;
}
.card {
  border: 1px solid #fff;
  padding: 20px 20px;
  border-radius: 12px;
  margin-top: 20px;
}
.campaign-top {
  justify-content: space-between;
}

.aply-contact img {
  display: none;
}

.slick-prev,
.slick-next {
  background-color: #55b56d !important;
  border: 2px solid white;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/navigation/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA;;;;;;;;GAQG;;AAEH;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,SAAS;EACT,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,2EAA2E;EAC3E,YAAY;EACZ,YAAY;;EAEZ,oCAAoC;EACpC,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,kBAAkB;EAClB,6EAA6E;EAC7E,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB,EAAE,6DAA6D;AACjF;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;AACA;CACC,iBAAiB;AAClB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,oCAAoC;EACpC,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".forms-sample .form-group .input {\r\n  display: grid;\r\n  grid-auto-flow: column;\r\n  position: relative;\r\n}\r\n\r\n.forms-sample .form-group .input img {\r\n  position: absolute;\r\n  width: 80px;\r\n  right: 12px;\r\n  padding: 0px;\r\n  height: 40px;\r\n  border-radius: 25.0415px;\r\n  border: 4px solid rgb(36 186 239 / 30%);\r\n}\r\n\r\n/* .active > .page-link,\r\n.page-link.active {\r\n  background-color: #328da7;\r\n  border-color: #328da7;\r\n}\r\n\r\n.page-link {\r\n  color: #328da7;\r\n} */\r\n\r\n.joblist {\r\n  background-color: #fff;\r\n  padding: 50px 30px;\r\n}\r\n\r\n.joblist h3 {\r\n  color: #000;\r\n}\r\n\r\n/* Sidebar */\r\n.sidebar {\r\n  /* position: fixed; */\r\n  top: 82px;\r\n  bottom: 0;\r\n  left: 0;\r\n  padding: 0px 0 0;\r\n  /* box-shadow: 0 2px 5px 0 rgb(0 0 0 / 5%), 0 2px 10px 0 rgb(0 0 0 / 5%); */\r\n  width: 240px;\r\n  z-index: 600;\r\n\r\n  background-color: #f3f6f9 !important;\r\n  padding-bottom: 22px;\r\n}\r\n.position-sticky {\r\n  background-color: #f3f6f9;\r\n}\r\n@media (max-width: 991.98px) {\r\n  .sidebar {\r\n    width: 100%;\r\n  }\r\n}\r\n.sidebar .active {\r\n  border-radius: 5px;\r\n  /* box-shadow: 0 2px 5px 0 rgb(0 0 0 / 16%), 0 2px 10px 0 rgb(0 0 0 / 12%); */\r\n  background-color: #55b56d;\r\n  border-color: #55b56d;\r\n  border-radius: 0px;\r\n}\r\n.sidebar-sticky {\r\n  position: relative;\r\n  top: 0;\r\n  height: calc(100vh - 48px);\r\n  padding-top: 0.5rem;\r\n  overflow-x: hidden;\r\n  overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */\r\n}\r\n\r\n.rightside {\r\n  width: 80%;\r\n  padding: 25px 30px;\r\n  background-color: #f3f6f9;\r\n}\r\n\r\n.profile header {\r\n  justify-content: space-between;\r\n}\r\n.profile {\r\n padding-top: 10px;\r\n}\r\n\r\n\r\n.profiless-img input {\r\n  width: 40px;\r\n  height: 40px;\r\n  opacity: 0;\r\n  cursor: pointer;\r\n  position: absolute;\r\n  right: 80px;\r\n  top: 74px;\r\n  z-index: 11;\r\n}\r\n\r\n.profiless-img {\r\n  position: relative;\r\n}\r\n\r\n.profiless-img i.fa.fa-camera {\r\n  /* background-color: #55b56d; */\r\n  width: 40px;\r\n  height: 40px;\r\n  position: absolute;\r\n  right: 80px;\r\n  top: 74px;\r\n  text-align: center;\r\n  padding: 9px 8px;\r\n  border-radius: 50%;\r\n  color: #55b56d;\r\n  z-index: 10;\r\n}\r\n\r\n.camping-hd h4 {\r\n  color: #212121;\r\n  font-size: 18px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 21px;\r\n}\r\n.camping-hd p {\r\n  color: #b5b5c3;\r\n  font-size: 12px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 21px;\r\n}\r\n.btn-all {\r\n  border-radius: 5px;\r\n  background: #55b56d;\r\n  color: #fff;\r\n  font-size: 12px;\r\n  font-family: Poppins;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: normal;\r\n  /* width: 140px; */\r\n  height: 41px;\r\n  padding: 12px 15px;\r\n}\r\n.card {\r\n  border: 1px solid #fff;\r\n  padding: 20px 20px;\r\n  border-radius: 12px;\r\n  margin-top: 20px;\r\n}\r\n.campaign-top {\r\n  justify-content: space-between;\r\n}\r\n\r\n.aply-contact img {\r\n  display: none;\r\n}\r\n\r\n.slick-prev,\r\n.slick-next {\r\n  background-color: #55b56d !important;\r\n  border: 2px solid white;\r\n  width: 30px;\r\n  height: 30px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
